export const BUDGET_LINE_ITEMS = (BUDGET_ID: string) => `v1/budgets/${BUDGET_ID}/line-items`;
